// extracted by mini-css-extract-plugin
export default {"timestamp":"Fh1NGDYW","message":"n7tdnvRd","content":"KnvEpgUr"};